<div class="progress-bar color-{{ color }} background" [style.height.px]="width"></div>
<div class="progress-bar color-{{ bar.color }}" [style.width.%]="(bar.value / max) * 100" *ngFor="let bar of displayBars"></div>
